declare global {
  interface Window {
    fbq?: (
      command: 'init' | 'track' | 'trackCustom',
      event: string,
      payload?: Record<string, any>,
    ) => void;
  }
}

export type MetaEvent =
  | 'PageView'
  | 'ViewContent'
  | 'AddToCart'
  | 'InitiateCheckout'
  | 'Purchase'
  | 'CompleteRegistration'
  | 'AddToWishlist';

const withFBQ = (cb: (fbq: NonNullable<typeof window.fbq>) => void) => {
  if (typeof window === 'undefined') return;
  const { fbq } = window;
  if (!fbq) return;

  cb(fbq);
};

export const fbqTrack = (event: MetaEvent, payload?: Record<string, any>) => {
  withFBQ((fbq) => fbq('track', event, payload));
};

export const fbqCustom = (event: string, payload?: Record<string, any>) => {
  withFBQ((fbq) => fbq('trackCustom', event, payload));
};

export const fbqPage = () => {
  withFBQ((fbq) => fbq('track', 'PageView'));
};
